import {RFValue} from 'react-native-responsive-fontsize';
import FontAwesome5 from 'react-native-vector-icons/FontAwesome5';
import styled from 'styled-components/native';

export const Container = styled.View`
  gap: ${RFValue(12)}px;
`;

export const Streak = styled.View``;

export const StreakTitleContainer = styled.View`
  flex-direction: row;
  align-items: center;
  gap:${RFValue(4)}px;

`;

export const StreakTitle = styled.Text`
  font-size: ${RFValue(14)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
`;
export const StreakText = styled.Text`
  color: ${({theme}) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.regular};
`;

export const StrakIcon = styled(FontAwesome5)`
  font-size: ${RFValue(14)}px;
  color:${({theme}) => theme.colors.primary};
`;
